import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import Firebase from '../../../Config/firebase';

// Css
import { Form } from './styles';

// Js
import { useForm } from '../../../Components/General/Form/useForm'
import { GlobalContext } from '../../../Global/GlobalContext';
import { updateTeam, getSingleTeam } from '../../../Global/api';
import { uploadImage } from '../../../Infra/General/ImageHelpers';
import ValidationRequired from '../../../Infra/General/Validation/ValidationRequired';

// Components
import Input from '../../../Components/General/Form/Input'
import InputFile from '../../../Components/General/Form/InputFile';
import ButtonOne from '../../../Components/General/Buttons/ButtonOne';
import Textarea from '../../../Components/General/Form/Textarea';

const Update = () => {
    const navigate = useNavigate();
    const location = useLocation();
    
    const { setLoading, showMessage } = React.useContext(GlobalContext);

    const arrPath = location.pathname.split('/');
    const id = arrPath[arrPath.length - 1];

    // Form
    const formRef = React.useRef(null);
    const name = useForm();
    const image = useForm();
    const imageRef = React.useRef(null);
    const content = useForm();
    const [imageExtraInf, setImageExtraInf] = React.useState('');

    React.useEffect(() => {
        setLoading(1);

        getSingleTeam(id)
            .then(res => {
                setLoading(0);
                
                name.setValue(res.data().name);
                content.setValue(res.data().content);
                setImageExtraInf(res.data().image)
            })
            .catch(res => {
                setLoading(0);
                showMessage('O item foi removido com sucesso', 200);
                navigate('/dashboard/equipes');
            });
    }, [])

    function onSubmit(e){
        e.preventDefault();
        const validation = new ValidationRequired(formRef.current);

        if(validation.isValid()) saveNewItem();
    }

    function saveNewItem(){
        setLoading(1);
        
        let imageFile = imageRef.current.files[0];
        let imageUpload = null;
        if(imageFile) imageUpload = uploadImage(imageFile, 'team');

        Promise.all( [ imageUpload ] ).then(image => 
            updateTeam({
                "name": name.value,
                "content": content.value,
                "image": image[0] ? image[0] : imageExtraInf
            }, id)
            .then(res => {
                showMessage('Dados salvos com sucesso', 200);
                setLoading(0);
                
                if(image[0]) setImageExtraInf(image[0]);
            })
            .catch(res => {
                setLoading(0);
                showMessage("Ocorreu um erro ao tentar atualizar o item", 400)
            })
        )
        .catch(err => {
            setLoading(0);
            showMessage("Ocorreu um erro ao tentar fazer o upload do arquivo", 400)
        });
    }

    return (
        <Form ref={formRef}>
            <h2>Editar Item</h2>

            <div className="inputs">
                <Input 
                    label="Nome"
                    name="name"
                    type="text"
                    validName="required"
                    className="input-standard"
                    {...name}
                />

                <InputFile 
                    name="Imagem"
                    label="image (358 x 166)" 
                    extraInformation=""
                    reference={imageRef}
                    extraInformation={imageExtraInf}
                    {...image}
                />

                <Textarea 
                    label="Conteúdo"
                    name="content"
                    type="text"
                    className="input-standard"
                    {...content}
                />

            </div>
            
            <ButtonOne
                width={200}
                height={50}
                onClick={onSubmit}
            >
                Enviar
            </ButtonOne>
        </Form>
    )
}

export default Update
